<template>
    <!-- modal desbloquear avaço fisico -->
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <BarTitle title="Autenticação" @close="closePassword()"></BarTitle>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field type="password" v-model="auth_password" label="Senha" outlined></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn class="mr-2" x-large text @click="closePassword()">FECHAR</v-btn>
              <v-btn
                :loading="loadingBtnPassword"
                :disabled="loadingBtnPassword"
                x-large
                color="primary"
                @click="sendPasswordConfirm()"
                >Confirmar</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>
<script>
import BarTitle from "@/pages/Components/BarTitle.vue";
import { mapActions } from "vuex";
export default {

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    compositionEdit: {
      type: Object,
      required: false,
    },
  },
  components: {
    BarTitle,
  },
  data() {
    return {
      dialog: false,
      auth_password: '',
      loadingBtnPassword: false,
    };
  },
  watch: {
    value(newVal) {
      this.dialog = newVal;
    },
    dialog(newVal) {
      this.$emit("input", newVal);

    },
  },
  methods: {
    ...mapActions("PhysicalProgress", ['saveHHUnitPhisycalProgress']),
    closePassword() {
        console.log('close password emit')
      this.$emit("canceled");
      this.dialog = false;
    },

    sendPasswordConfirm() {


      this.loadingBtnPassword = true;
      const data = {
        password: this.auth_password,
        physical_progress_item: this.compositionEdit.pivot,
      };

      this.saveHHUnitPhisycalProgress(data)
        .then(() => {
          this.$emit("confirmed");
          ///this.calcHH(this.compositionEdit);
          this.dialog = false;
          this.$toast.success("Salvo com sucesso");
        })
        .catch((error) => {
          if (error.response.status == 423) {
            this.$toast.error(error.response.data);
          }
        })
        .finally(() => {
          this.loadingBtnPassword = false;
        });
    },
  },
};
</script>
